import config from '../config/config.json';

const hostFrontend = config.production.hostFrontend;

/* URL LOGO */
export const urlLogo = hostFrontend + "/logowebapp.png";